class PagePopup extends HTMLElement {
  connectedCallback() {
    if(!this.parentNode.isEqualNode(document.querySelector('body'))) {
      this.wrapper = this.closest('popup-wrapper');
      document.querySelector('body').append(this);
      return;
    }
    this.id = this.dataset.popupId;
    if(!this.id) {
      throw new Error("Page popup ID is required.");
    }
    this.hasOverlay = this.hasAttribute('data-include-overlay');

    this.querySelectorAll(`[data-close-popup="${this.id}"]`).forEach(i => {
      i.addEventListener('click', this.handleClose.bind(this))
    })
    this.wrapper?.querySelectorAll('[data-open-popup="peer"]')?.forEach(i => {
      i.addEventListener('click', this.handleOpen.bind(this));
    })
  }

  set state(value) {
    this.setAttribute('data-state', value);
  }

  get state() {
    return this.dataset.state;
  }

  close() {
    this.state = 'inactive';
    this.removeOverlay();
    if(!document.querySelector('page-drawer[data-drawer-state=open]')
      && !document.querySelector('page-popup[data-state=active]')) {
      setTimeout(() => {
        document.documentElement.style.scrollbarGutter = 'stable'
        document.documentElement.style.overflow = 'auto';
        ScrollSmoother.get().paused(false);
      }, 50) 
    }
  }

  open() {
    this.state = 'active';
    setTimeout(() => {
      document.documentElement.style.scrollbarGutter = 'auto';
      document.documentElement.style.overflow = 'hidden';
      ScrollSmoother.get().paused(true);
    }, 400)
    if(this.hasOverlay  && !document.getElementById(`overlay-${this.id}`)) {
      this.addOverlay();
    }
  }

  handleClose(e) {
    e.preventDefault();
    this.close();
  }

  handleOpen(e) {
    e.preventDefault();
    this.open();
  }

  removeOverlay() {
    const overlay = document.getElementById(`overlay-${this.id}`);
    if(overlay) {
      document.body.removeChild(overlay);
    }
  }

  addOverlay() {
    const overlay = document.createElement('div');
    overlay.style.opacity = 0;
    overlay.setAttribute('id', `overlay-${this.id}`);
    overlay.setAttribute('class', this.dataset.includeOverlay);
    document.body.insertBefore(overlay, this)
    overlay.addEventListener('click', this.handleClose.bind(this));
    setTimeout(() => {
      overlay.style.opacity = 1;
    }, 50)
  }
}

customElements.define('page-popup', PagePopup);